import { createUseStyles } from "react-jss";

const styles = createUseStyles({
  spendTab: {
    //
  }
});

export default styles;
